import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

/**
 * Every "Extend booking time" dialog: one on the booking page, one per
 * booking card in the chat, which loads its messages after the page.
 * Delegated, so each dialog's duration updates its own calculation.
 */
export const initBookingAddonTime = () => {
  document.addEventListener("change", (e) => {
    const selectElement = e.target as HTMLElement;

    if (!(selectElement instanceof HTMLSelectElement)) {
      return;
    }

    const bookingAddonTime = selectElement.closest<HTMLFormElement>("form.booking-addon-time");

    if (!bookingAddonTime || !selectElement.classList.contains("addonTimeDuration")) {
      return;
    }

    if (!selectElement.value) {
      return;
    }

    const dayjsDuration = dayjs.duration(parseInt(selectElement.value, 10), "minutes");

    const durationAsHours = dayjsDuration.asHours();
    const durationHours = Math.floor(dayjsDuration.asHours());
    const durationMinutes = dayjsDuration.minutes();

    const addonTimeCalculation = bookingAddonTime.querySelector(
      ".addonTimeCalculation",
    ) as HTMLDivElement;

    const calculationHours = addonTimeCalculation.querySelector(".hours") as HTMLSpanElement;
    const calculationMinutes = addonTimeCalculation.querySelector(".minutes") as HTMLSpanElement;
    const calculationMinutesLabel = addonTimeCalculation.querySelector(
      ".minutes-label",
    ) as HTMLSpanElement;

    const calculationFormattedRateMoney = addonTimeCalculation.querySelector(
      ".formatted-rate-money",
    ) as HTMLSpanElement;
    const calculationFormattedTotalMoney = addonTimeCalculation.querySelector(
      ".formatted-total-money",
    ) as HTMLDivElement;

    calculationHours.textContent = durationHours.toString();
    calculationMinutes.textContent = durationMinutes.toString();

    calculationMinutes.style.display = "inline-block";
    calculationMinutesLabel.style.display = "inline-block";

    if (durationMinutes === 0) {
      calculationMinutes.style.display = "none";
      calculationMinutesLabel.style.display = "none";
    }

    /* Calculate total money */
    const rateMoneyAmount = addonTimeCalculation.dataset.amount as unknown as number;
    const moneyCurrency = addonTimeCalculation.dataset.currency;

    const totalMoneyAmount = rateMoneyAmount * durationAsHours;

    const locale = document.documentElement.lang;

    const formattedRateMoney = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: moneyCurrency,
    }).format(rateMoneyAmount);

    const formattedTotalMoney = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: moneyCurrency,
    }).format(totalMoneyAmount);

    calculationFormattedRateMoney.textContent = formattedRateMoney;
    calculationFormattedTotalMoney.textContent = formattedTotalMoney;
  });
};
